import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { PortalAPI } from '../../../api/portal.api';
import { colors } from '../../../colors';

import { DatahubSettings } from '../../../containers/DatahubSettings.container';
import { LoadingPanel } from 'Common/LoadingPanel';
import Button from 'Common/Button/Button';

import type { RootState } from '../../../types/state.types';

export const StacktracePage: React.FC = () => {
  const portalUrl = useSelector((state: RootState) => state.subscription.url);
  const token = useSelector((state: RootState) => state.subscription.token);
  const [stacktraceHTML, setStacktraceHTML] = useState<string>();

  const refresh = () => {
    getStacktrace();
  };

  const getStacktrace = async () => {
    const result = await PortalAPI.getStacktrace(portalUrl, token);

    setStacktraceHTML(result);
  };

  useEffect(() => {
    if (token) {
      getStacktrace();
    }
  }, [token]);

  if (!stacktraceHTML) {
    return <LoadingPanel />;
  }

  return (
    <DatahubSettings>
      <div
        style={{
          overflow: 'scroll',
        }}
      >
        <Button text="Refresh" onClick={refresh} />
        <div
          dangerouslySetInnerHTML={{ __html: stacktraceHTML }}
          style={{
            backgroundColor: colors.light.background.semilight,
            color: 'black',
            paddingLeft: '0.5em',
          }}
          // the stacktrace has it's own styles that we can't change but the
          // main text in it is not styled - that's where our styling takes over
          // with this, we simply set the text to black so that it's always visible
        />
      </div>
    </DatahubSettings>
  );
};
